import {CommandStrategy} from './base/CommandStarategy';
import {PieMenuIcons} from '../PieMenuIcons';
import {Card} from '../../../game_table/table_objects/stacks/Card';
import {Stack} from '../../../game_table/table_objects/stacks/Stack';
import {CardData} from '../../../../../data/active_data/field_config/card_stack_data/CardData';
import {DynamicData} from '../../../../../data/DynamicData';
import {DrawController} from '../../../../../controllers/DrawController';

export class ZoomStackCommandStarategy extends CommandStrategy
{
    private stack: Stack | undefined;

    constructor() {
        super({iconId: PieMenuIcons.MAG, hint: 'Preview\n(Space)'});
    }

    isApplicable(card: Card | undefined, stack: Stack | undefined): boolean {
        this.stack = stack;
        return !card && !!stack && DynamicData.settings.canTablePreviewCards;
    }

    execute(commandIndex: number): void {
        let cardData: CardData = this.stack!.activeData.cards.getLast();
        DrawController.zoomCard(cardData);
    }
}
